import React from 'react';
import { motion } from 'framer-motion';
import { UserPlus, Wallet, CreditCard, ArrowRight } from 'lucide-react';
export function HowItWorks() {
  const openWhatsApp = () => {
    window.open('https://wa.me/2250700592164', '_blank', 'noopener,noreferrer');
  };
  const steps = [{
    icon: UserPlus,
    title: 'Créez votre compte',
    description: 'Inscrivez-vous en quelques secondes pour accéder à votre tableau de bord et commencer.',
    color: 'from-blue-500 to-blue-600',
    iconBg: 'bg-blue-100',
    iconColor: 'text-blue-600'
  }, {
    icon: Wallet,
    title: 'Rechargez avec Wave',
    description: 'Ajoutez des fonds instantanément à votre carte virtuelle via Wave Mobile Money.',
    color: 'from-emerald-500 to-emerald-600',
    iconBg: 'bg-emerald-100',
    iconColor: 'text-emerald-600'
  }, {
    icon: CreditCard,
    title: 'Payez partout',
    description: 'Utilisez votre carte Visa USD pour tous vos paiements internationaux sans limites.',
    color: 'from-purple-500 to-purple-600',
    iconBg: 'bg-purple-100',
    iconColor: 'text-purple-600'
  }];
  return <section id="how-it-works" className="py-20 bg-gradient-to-b from-white to-gray-50" data-id="element-224">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-226">
          <h2 className="text-4xl font-extrabold text-gray-900 mb-4" data-id="element-227">
            Comment ça marche
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-228">
            Trois étapes simples pour commencer à payer sans limites
          </p>
        </motion.div>

        <div className="relative" data-id="element-229">
          {/* Connection line - desktop only */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-blue-200 via-emerald-200 to-purple-200 mx-auto" style={{
          width: '70%',
          left: '15%'
        }} data-id="element-230"></div>

          <div className="grid md:grid-cols-3 gap-8 lg:gap-12 relative" data-id="element-231">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="relative" data-id="element-232">
                <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow relative z-10" data-id="element-233">
                  {/* Step number badge */}
                  <div className={`absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br ${step.color} rounded-full flex items-center justify-center shadow-lg`} data-id="element-234">
                    <span className="text-white text-xl font-bold" data-id="element-235">
                      {index + 1}
                    </span>
                  </div>

                  {/* Icon */}
                  <div className={`w-16 h-16 ${step.iconBg} rounded-2xl flex items-center justify-center mb-6 mx-auto`} data-id="element-236">
                    <step.icon className={`w-8 h-8 ${step.iconColor}`} data-id="element-237" />
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3 text-center" data-id="element-238">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-center" data-id="element-239">
                    {step.description}
                  </p>
                </div>

                {/* Arrow connector - desktop only */}
                {index < steps.length - 1 && <div className="hidden lg:flex absolute top-24 -right-6 z-20 items-center justify-center" data-id="element-240">
                    <ArrowRight className="w-8 h-8 text-gray-300" data-id="element-241" />
                  </div>}
              </motion.div>)}
          </div>
        </div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="text-center mt-16" data-id="element-242">
          <button onClick={openWhatsApp} className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-medium rounded-full text-white bg-gradient-to-r from-blue-600 to-emerald-600 hover:from-blue-700 hover:to-emerald-700 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-243">
            Commencer maintenant
            <ArrowRight className="ml-2 w-5 h-5" data-id="element-244" />
          </button>
        </motion.div>
      </div>
    </section>;
}